import {IconProps} from '../../types/IconProps'

const TimeIcon = ({height, width, color}: IconProps) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width || '18'}
      height={height || '18'}
      viewBox='0 0 16 16'
      fill='none'
    >
      <g clipPath='url(#clip0_2852_3699)'>
        <path
          d='M8 0C6.41775 0 4.87104 0.469192 3.55544 1.34824C2.23985 2.22729 1.21447 3.47672 0.608967 4.93853C0.00346629 6.40034 -0.15496 8.00887 0.153721 9.56072C0.462403 11.1126 1.22433 12.538 2.34315 13.6569C3.46197 14.7757 4.88743 15.5376 6.43928 15.8463C7.99113 16.155 9.59966 15.9965 11.0615 15.391C12.5233 14.7855 13.7727 13.7602 14.6518 12.4446C15.5308 11.129 16 9.58225 16 8C15.9977 5.87897 15.1541 3.84547 13.6543 2.34568C12.1545 0.845886 10.121 0.00229405 8 0ZM8 14.6667C6.68146 14.6667 5.39253 14.2757 4.2962 13.5431C3.19987 12.8106 2.34539 11.7694 1.84081 10.5512C1.33622 9.33305 1.2042 7.99261 1.46144 6.6994C1.71867 5.40619 2.35361 4.21831 3.28596 3.28596C4.21831 2.35361 5.4062 1.71867 6.6994 1.46143C7.99261 1.2042 9.33305 1.33622 10.5512 1.8408C11.7694 2.34539 12.8106 3.19987 13.5431 4.2962C14.2757 5.39253 14.6667 6.68146 14.6667 8C14.6647 9.76752 13.9617 11.4621 12.7119 12.7119C11.4621 13.9617 9.76752 14.6647 8 14.6667Z'
          fill={color || 'black'}
        />
        <path
          d='M8.66927 7.7266V4.0026C8.66927 3.82579 8.59903 3.65622 8.47401 3.5312C8.34898 3.40618 8.17942 3.33594 8.0026 3.33594C7.82579 3.33594 7.65622 3.40618 7.5312 3.5312C7.40618 3.65622 7.33594 3.82579 7.33594 4.0026V8.0026C7.33598 8.1794 7.40624 8.34894 7.53127 8.47394L9.53127 10.4739C9.65701 10.5954 9.82541 10.6626 10.0002 10.6611C10.175 10.6595 10.3422 10.5894 10.4658 10.4658C10.5894 10.3422 10.6595 10.175 10.6611 10.0002C10.6626 9.82541 10.5954 9.65701 10.4739 9.53127L8.66927 7.7266Z'
          fill={color || 'black'}
        />
      </g>
      <defs>
        <clipPath id='clip0_2852_3699'>
          <rect width='16' height='16' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export default TimeIcon
